export default __webpack_public_path__ + "static/media/Pretendard-Black.fe80bd8c.woff";